"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.v17Upgrade = exports.v17Downgrade = void 0;
const v17Downgrade = (rule) => {
    const { ubCode, clientUuid, embUuid, variants, trigger, published, frequency, referrerTargets, id, event, version, parentVersion, meta, urlTargets, cookieTargets, geoTargets, scheduling, } = rule;
    return {
        schemaVersion: 16,
        ubCode,
        clientUuid,
        embUuid,
        variants,
        trigger,
        published,
        frequency,
        referrerTargets,
        id,
        integrations: {
            googleAnalytics: {
                enabled: rule.integrations.googleAnalytics.enabled,
            },
        },
        event,
        version,
        parentVersion,
        meta,
        urlTargets,
        cookieTargets,
        geoTargets,
        scheduling,
    };
};
exports.v17Downgrade = v17Downgrade;
const v17Upgrade = (rule) => {
    const { ubCode, clientUuid, embUuid, variants, trigger, published, frequency, referrerTargets, id, event, version, parentVersion, meta, urlTargets, cookieTargets, geoTargets, scheduling, } = rule;
    return {
        schemaVersion: 17,
        ubCode,
        clientUuid,
        embUuid,
        variants,
        trigger,
        published,
        frequency,
        referrerTargets,
        id,
        integrations: {
            googleAnalytics: {
                enabled: rule.integrations.googleAnalytics.enabled,
                appendVariant: false,
            },
        },
        event,
        version,
        parentVersion,
        meta,
        urlTargets,
        cookieTargets,
        geoTargets,
        scheduling,
    };
};
exports.v17Upgrade = v17Upgrade;
//# sourceMappingURL=v17.js.map